// Phones: a run toggle next to the phone button (desktop: hold Shift). Long trips auto-run anyway.
import { moveMode, phoneOpen, playerLoc, runOn } from "../bridge";

export function RunToggle() {
  if (phoneOpen.value || playerLoc.value.driving) return null;
  const on = runOn.value;
  return (
    <button
      class={`run-toggle ${on ? "on" : ""}`}
      aria-pressed={on}
      aria-label={on ? "Running (tap to walk)" : "Walking (tap to run)"}
      onClick={() => {
        moveMode.run = !on;
        runOn.value = !on;
      }}
    >
      {on ? "🏃" : "🚶"}
    </button>
  );
}
